import { useState } from 'react';
import { motion } from 'framer-motion';
import { LOTS } from './data';

// CATALOGUE — auction lot index. Long table-style listing with thumb on left,
// wall-caption style rows. Click row to expand into a detail panel.
export default function Catalogue() {
  const [open, setOpen] = useState(null);
  return (
    <div className="bg-[#F4F1EA] text-[#0A0A0A]">
      <section className="pt-12 pb-10 max-w-[1500px] mx-auto px-8 lg:px-14 border-b border-[#0A0A0A]/15">
        <p className="font-mono text-[10px] tracking-[0.4em] uppercase text-[#B53024] mb-4">— Auction · 14 October 2026 · London & live</p>
        <div className="grid lg:grid-cols-[1.6fr_1fr] gap-8 items-end">
          <h1 className="font-serif text-[44px] sm:text-[64px] lg:text-[88px] leading-[1.02] tracking-tight">The lot <span className="italic text-[#B53024]">index</span>.</h1>
          <p className="font-serif italic text-lg text-[#0A0A0A]/65 leading-[1.5] max-w-md">Fifty-two lots in total. The six headline pieces are listed below; the full catalogue ships in printed form to registered bidders ten weeks before the sale.</p>
        </div>
      </section>

      {/* Lot index — typographic table */}
      <section className="max-w-[1500px] mx-auto px-8 lg:px-14 py-8">
        {LOTS.map((l, i) => (
          <motion.div key={l.n} initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} viewport={{ once: true }} transition={{ delay: i * 0.04 }}
            className="border-b border-[#0A0A0A]/15">
            <button onClick={() => setOpen(open === i ? null : i)} className="w-full grid grid-cols-[110px_1fr_auto] sm:grid-cols-[160px_1fr_auto] gap-6 py-6 text-left items-center hover:bg-[#EDE6D8] transition-colors px-4 -mx-4" data-testid={`art-lot-${l.n.split(' ')[1]}`}>
              <div className="aspect-square overflow-hidden bg-[#EDE6D8] border border-[#0A0A0A]/10"><img src={l.img} alt="" className="w-full h-full object-cover" loading="lazy" /></div>
              <div>
                <p className="font-mono text-[10px] tracking-[0.3em] uppercase text-[#B53024] mb-1">{l.n}</p>
                <p className="font-serif text-xl lg:text-2xl leading-tight" dangerouslySetInnerHTML={{ __html: l.title }} />
                <p className="font-serif italic text-sm text-[#0A0A0A]/60 mt-1">{l.med}</p>
              </div>
              <p className="font-serif text-lg lg:text-xl text-[#B53024] whitespace-nowrap text-right">{l.est}</p>
            </button>
            {open === i && (
              <motion.div initial={{ height: 0, opacity: 0 }} animate={{ height: 'auto', opacity: 1 }} className="px-4 -mx-4 overflow-hidden">
                <div className="grid lg:grid-cols-[1fr_1.4fr] gap-10 py-8 border-t border-[#0A0A0A]/10">
                  <div className="aspect-[4/5] overflow-hidden bg-[#EDE6D8] p-8"><img src={l.img} alt="" className="w-full h-full object-cover" /></div>
                  <div>
                    <table className="font-mono text-[12px] w-full">
                      <tbody>
                        {[['Lot', l.n], ['Title', l.title.split(' — ')[1] || l.title], ['Artist', l.title.split(' — ')[0]], ['Medium', l.med], ['Provenance', l.prov], ['Estimate', l.est], ['Condition', '— Excellent · catalogue grade A —']].map(([k, v]) => (
                          <tr key={k} className="border-b border-[#0A0A0A]/10"><td className="py-3 text-[#0A0A0A]/45 tracking-[0.2em] uppercase w-32">{k}</td><td className="py-3" dangerouslySetInnerHTML={{ __html: v }} /></tr>
                        ))}
                      </tbody>
                    </table>
                    <div className="mt-8 flex gap-3 flex-wrap">
                      <button className="bg-[#0A0A0A] text-[#F4F1EA] px-5 py-3 font-mono text-[10px] tracking-[0.3em] uppercase hover:bg-[#B53024]">Register to bid →</button>
                      <button className="border border-[#0A0A0A]/30 text-[#0A0A0A] px-5 py-3 font-mono text-[10px] tracking-[0.3em] uppercase hover:border-[#B53024] hover:text-[#B53024]">Request condition report</button>
                    </div>
                  </div>
                </div>
              </motion.div>
            )}
          </motion.div>
        ))}
      </section>
    </div>
  );
}
